export enum DecisionStatus {
  Pending = "PENDING",
  Acknowledged = "ACKNOWLEDGED",
  Approved = "APPROVED",
  Denied = "DENIED",
  NoLongerParticipating = "NO_LONGER_PARTICIPATING",
  Withdrawn = "WITHDRAWN",
}

export enum InvitationStatus {
  Cancelled = "CANCELLED",
  Accepted = "ACCEPTED",
  Declined = "DECLINED",
  Pending = "PENDING",
  PendingUserActivation = "PENDING_USER_ACTIVATION",
  ComplianceReviewRequired = "COMPLIANCE_REVIEW_REQUIRED",
  InvitationEmailSendFailed = "INVITATION_EMAIL_SEND_FAILED",
}

export enum InvitedHAsAction {
  ManageInvitation = "MANAGE_INVITATION",
  AddMoreInvitees = "ADD_MORE_INVITEES",
  ResendInvitation = "RESEND_INVITATION",
  ViewInvitation = "VIEW_INVITATION",
  CancelInvitation = "CANCEL_INVITATION",
}

export enum ParticipationType {
  LeadHA = "LEAD_HEALTH_AUTHORITY",
  ReferenceHA = "REFERENCE_HEALTH_AUTHORITY",
  Rapporteur = "RAPPORTEUR",
  CoRapporteur = "CO_RAPPORTEUR",
  Module3Reviewer = "MODULE_3_REVIEWER",
  Module4Reviewer = "MODULE_4_REVIEWER",
  Module5Reviewer = "MODULE_5_REVIEWER",
  Participant = "PARTICIPANT",
  RelianceHA = "RELIANCE_HEALTH_AUTHORITY",
  Observer = "OBSERVER",
}

export const DEFAULT_DECISION_STATUS = DecisionStatus.Pending;

export const DEFAULT_DECISION_STATUS_ORDER = [
  DecisionStatus.Approved,
  DecisionStatus.Acknowledged,
  DecisionStatus.Denied,
  DecisionStatus.Pending,
  DecisionStatus.NoLongerParticipating,
  DecisionStatus.Withdrawn,
];

export const DEFAULT_RESPONSE_STATUS_ORDER = [
  InvitationStatus.Pending,
  InvitationStatus.Accepted,
  InvitationStatus.Declined,
];

export const PENDING_INVITATION_STATUSES = [
  InvitationStatus.Pending,
  InvitationStatus.PendingUserActivation,
  InvitationStatus.ComplianceReviewRequired,
  InvitationStatus.InvitationEmailSendFailed,
];

export const RESEND_ELIGIBLE_STATUSES = [
  InvitationStatus.Pending,
  InvitationStatus.PendingUserActivation,
  InvitationStatus.Declined,
];
